
(function ($) {

	var $logo = $('.standard-logo__image__animation');
	var $header = $('.js-page-header');

	var stopLogoAnimation = function () {
		$logo.removeClass('animate-stopped');
		$logo.removeClass('animate-normal');
		$logo.addClass('animate-end');
	};

	var startLogoAnimation = function () {
		$logo.removeClass('animate-stopped');
		$logo.removeClass('animate-end');
		$logo.addClass('animate-normal');
	};

	var displaySolidHeader = function () {
		$header.addClass('page-header-solid');
	}

	var hideSolidHeader = function () {
		$header.removeClass('page-header-solid');
	}

	$(window).scroll(function () {
		var scroll = $(window).scrollTop();

		if (scroll <= 0) {
			startLogoAnimation();
			hideSolidHeader();

		} else {
			stopLogoAnimation();
			displaySolidHeader();
		}
	});


	window.addEventListener('load', function () {
		startLogoAnimation();
	})

})(jQuery);